import { split } from './link-helper';

import Image from 'components/image/Image';
import Icon, { type IconName } from 'components/icon/Icon';

import ArrowIconSrc from 'images/arrow-rounded.svg';

interface ExternalLinkProps {
  text?: string;
  iconClassName?: string;
  iconBeforeChildren?: IconName;
  icon?: IconName;
  useSkinnyIcon?: boolean;
  isActionLink?: boolean;
}

const ExternalLink: React.FC<React.PropsWithChildren<ExternalLinkProps>> = ({
  text,
  children,
  iconClassName,
  iconBeforeChildren,
  icon,
  useSkinnyIcon,
  isActionLink
}) => {
  const parts = text?.split(' ') ?? [];
  const withoutLast = parts.slice(0, -1).join(' ');
  const last = parts.length ? ` ${parts[parts.length - 1]}` : '';

  return (
    <span>
      {iconBeforeChildren && <Icon className={iconClassName} name={iconBeforeChildren} />}
      {isActionLink && (
        <div className="action-link-icon">
          <Image src={ArrowIconSrc} alt="ikon" isArrowIcon={true} width={24} height={24} isFluid={true} />
        </div>
      )}

      {/* Text and Icon */}
      <>
        {children}
        <span className="link--text">
          {split(withoutLast)}
          <span style={{ whiteSpace: 'nowrap' }}>
            {last}
            <Icon
              {...(useSkinnyIcon
                ? {
                    name: 'external-link-arrow-skinny',
                    className: 'external-link-icon-skinny'
                  }
                : {
                    name: 'external-link-arrow',
                    className: 'external-link-icon'
                  })}
            />
          </span>
        </span>
      </>

      {icon && <Icon className={iconClassName} name={icon} />}
    </span>
  );
};

ExternalLink.displayName = 'ExternalLink';

export default ExternalLink;
